import { Component, OnInit, Input } from '@angular/core';
import { Http, Response } from '@angular/http'

@Component({
  selector: 'app-moviesearch',
  templateUrl: './moviesearch.component.html',
  styleUrls: ['./moviesearch.component.css']
})
export class MoviesearchComponent implements OnInit {
  datas: []
  loading: boolean
  text: string
  searched: boolean

  constructor(public http: Http) { }

  ngOnInit() {
    this.searched = false
    this.text = 'You have not Search for any Movies'
  }
  Search(value: string) {
    this.loading = true
    this.searched = true
    this.datas = []
    this.http.request(`https://cors-everywhere.herokuapp.com/http://www.omdbapi.com/?s=${value.search}&plot=full&apikey=e51cc621`)
      .subscribe((res: Response) => {
        this.datas = res.json().Search
        this.loading = false

      })

    return false

  }

}
